// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyC3DDO4sSuIJS024Fx7P8h8EhJe9Q9LDVk",
  authDomain: "chatting-application-a098e.firebaseapp.com",
  projectId: "chatting-application-a098e",
  storageBucket: "chatting-application-a098e.appspot.com",
  messagingSenderId: "104355846477",
  appId: "1:104355846477:web:ab430bfccf24a4e3947f04",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export default firebaseConfig;
